'use client'

import React from 'react'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { MediaKitDescriptionMock } from '@components/MediaKit/MediaKitMock'
import styles from './MediaKitDescription.module.scss'

const MediaKitDescription = () => {
  const { ref: titleRef, animationClassName: titleClass } = useAnimateOnVisible<HTMLParagraphElement>()
  const { ref: descRef, animationClassName: descClass } = useAnimateOnVisible<HTMLParagraphElement>({
    animationDelayMs: 60,
  })
  return (
    <div className={styles.mediaKitDescriptionContainer}>
      <p ref={titleRef} className={`${styles.mediaKitTitle} ${titleClass}`}>
        {MediaKitDescriptionMock.title}
      </p>
      <p ref={descRef} className={`${styles.mediaKitDescription} ${descClass}`}>
        {MediaKitDescriptionMock.description}
      </p>
    </div>
  )
}

export default MediaKitDescription
